<template>
  <div class="table-responsive">
    <table id="notifications-table" class="table table-striped">
      <thead>
        <tr>
          <th>{{$t('profile.notifications.entity')}}</th>
          <th>{{$t('profile.notifications.subscribed_notifications')}}</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(entity, index) in filteredEntities" :key="index">
          <td>
            {{ formatedEntityLabel(entity) }}
          </td>
          <td>
            <div v-if="updateIndex === index">
              <div class="form-group" style="margin-bottom:0rem;">
                <div class="input-group clearable-filter">
                  <multiselect
                    v-model="subscribedNotifications"
                    :options="notificationsAvailableForSubscription"
                    track-by="id"
                    label="type"
                    deselect-label="×"
                    :placeholder="$t('profile.notifications.no_notifications_selected')"
                    :allow-empty="true"
                    :multiple="true"
                    :searchable="true"
                    :close-on-select="false"
                    :limit="previewNotificationsLimit"
                    :limitText="multiselectLimitText"
                    open-direction="bottom"
                    >

                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        <span>{{$t(`profile.notifications.types.${option.type}`)}}&nbsp;
                        </span>
                        <i @click="remove(option)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                      </span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <span class="option__name">
                        {{$t(`profile.notifications.types.${option.type}`)}}
                      </span>
                    </template>
                    <template slot="clear">
                      <div class="multiselect__clear" v-if="subscribedNotifications.length" @mousedown.prevent.stop="subscribedNotifications = []"></div>
                    </template>
                    <span slot="noResult">{{$t('profile.notifications.multiselect_no_results')}}</span>
                  </multiselect>
                </div>
              </div>
            </div>

            <div v-else>
              <!-- <div v-if="notificationsSubscribedByEntity[entity.id].length > 0" class="row align-items-center">
                <span v-for="(notification, j) in notificationsSubscribedByEntity[entity.id].slice(0, previewNotificationsLimit)" :key="j"
                    class="custom-tag my-1"
                  >
                {{$t(`profile.notifications.types.${notification.type}`)}}
                </span>
                <span v-if="notificationsSubscribedByEntity[entity.id].length - previewNotificationsLimit > 0"
                    class="custom-tag my-1"
                  >
                  {{$t('profile.notifications.more_entities', {number: notificationsSubscribedByEntity[entity.id].length - previewNotificationsLimit})}}
                </span>
              </div>
              <div v-else>
                  {{$t('profile.notifications.no_subscribed_entities')}}
              </div> -->
            </div>
          </td>

          <td>
            <div class="d-flex justify-content-end pr-3">
              <va-popover
                :message="$t('profile.notifications.update_subscriptions')"
                placement="left"
              >
                <i v-show="updateIndex == null" class="fa fa-pencil green-icon" @click="setupUpdate(index)"></i>
              </va-popover>
              <va-popover
                :message="$t('profile.notifications.confirm_update_subscriptions')"
                placement="left"
              >
                <i v-show="updateIndex !== null && updateIndex === index " class="fa fa-check px-2 green-icon" @click="confirmUpdate"></i>
              </va-popover>
              <va-popover
                :message="$t('profile.notifications.cancel')"
                placement="left"
              >
                <i v-show="updateIndex !== null && updateIndex === index" class="fa fa-times px-2 green-icon" @click="cancelUpdate"></i>
              </va-popover>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import Multiselect from 'vue-multiselect'
import ShowPartialOrFullList from '@/components/common/ShowPartialOrFullList'
import { UserNotifications } from '@/api/Notifications'

export default {
  props: {
    notifications: {
      type: Array,
      required: true
    },
    userNotifications: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      required: true
    }
  },
  mixins: [
    MultiselectLabelFormatter
  ],
  components: {
    Multiselect,
    ShowPartialOrFullList
  },
  data: function () {
    return {
      previewNotificationsLimit: 4,
      updateIndex: null,
      notificationsAvailableForSubscription: [],
      subscribedNotifications: [],
    }
  },
  computed: {
    notificationsSubscribedByEntity: function () {
      let notificationsByEntity = {}
      if (this.globalAuthService.entities.length > 0) {
        this.globalAuthService.entities.forEach(entity => {
          notificationsByEntity[entity.id] = this.userNotifications
            .filter(userNotification => userNotification.entity_id === entity.id)
            .map(userNotification =>
              this.notifications.find(notification =>
                userNotification.notification_id === notification.id))
        })
      }
      console.log(notificationsByEntity)
      return notificationsByEntity
    },
    notificationsAvailableForSubscriptionByEntity: function () {
      let notificationsByEntity = {}
      if (this.notifications.length > 0 && this.globalAuthService.entities.length > 0) {
        this.globalAuthService.entities.forEach(entity => {
          notificationsByEntity[entity.id] = this.notifications
            .filter(notification => {
              return this.filterNotificationsByPermission(notification, entity)
            })
        })
      }
      return notificationsByEntity
    },
    globalAuthService: function () {
      return this.$store.getters.globalAuthService
    },
    filteredEntities: function () {
      let filteredEntities = this.globalAuthService.entities
        .filter(entity => this.notificationsAvailableForSubscriptionByEntity[entity.id].length > 0)

      if (this.search.trim()) {
        let lowercaseSearch = this.search.toLowerCase()
        filteredEntities = filteredEntities.filter(entity => entity.name.toLowerCase().includes(lowercaseSearch))
      }
      return filteredEntities
    }
  },
  mounted () {
    this.$emit('finishedMount')
  },
  methods: {
    filterNotificationsByPermission: function (notification, entity) {
      let notificationPermissions = this.globalAuthService.user_permissions
        .filter(permission =>
          permission.info_type === notification.info_type.type &&
          permission.access_type >= notification.access_type)

      if (notificationPermissions.length > 0) {
        return notificationPermissions
          .some(permission => permission.entity_id === null ||
            permission.entity_id === entity.id)
      } else {
        return false
      }
    },
    setupUpdate: function (index) {
      this.updateIndex = index
      let entity = this.filteredEntities[index]
      this.subscribedNotifications = this.notificationsSubscribedByEntity[entity.id]
      this.notificationsAvailableForSubscription = this.notificationsAvailableForSubscriptionByEntity[entity.id]
    },
    cancelUpdate: function () {
      this.updateIndex = null
      this.subscribedNotifications = []
      this.notificationsAvailableForSubscription = []
    },
    confirmUpdate: function () {
      let entity = this.filteredEntities[this.updateIndex]

      let data = {
        entity_id: entity.id,
        notifications: this.subscribedNotifications.map(notification => notification.id)
      }

      //let userId = this.$auth.user().id
      let userId = this.$route.params.id
      UserNotifications.update(userId, data)
        .then(userNotifications => {
          this.$emit('updatedUserNotifications', userNotifications)
          this.cancelUpdate()
        })
        .catch(() => {
          this.showToast(this.$t('profile.notifications.something_went_wrong'), this.$store.state.errorToastOptions)
        })
    },
    multiselectLimitText: function (count) {
      return this.$t('profile.notifications.multiselect_limit_text', { number: count })
    }
  }
}
</script>
